// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2eKh2","content":"styles_content__1M-Q-","row":"styles_row__1YXQD","footer":"styles_footer__fAUaW","phraseLength":"styles_phraseLength__3a4L9"};